'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _report = require('./report.service');

var _report2 = _interopRequireDefault(_report);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reportModule = _angular2.default.module('report.service', []).service('Report', _report2.default).name;

exports.default = reportModule;


// WEBPACK FOOTER //
// ./client/app/services/reportService/report.js